import { createWishlistStore } from './b-wishlist-store.js';

const store = createWishlistStore();

function sync(root = document) {
  const list = store.list();
  root.querySelectorAll('[data-wishlist-handle]').forEach((btn) => {
    btn.setAttribute('aria-pressed', String(list.includes(btn.dataset.wishlistHandle)));
  });
}

document.addEventListener('click', (event) => {
  const btn = event.target.closest('[data-wishlist-handle]');
  if (!btn) return;
  event.preventDefault();
  const saved = store.toggle(btn.dataset.wishlistHandle);
  document.querySelectorAll(`[data-wishlist-handle="${CSS.escape(btn.dataset.wishlistHandle)}"]`)
    .forEach((b) => b.setAttribute('aria-pressed', String(saved)));
  document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { list: store.list(), handle: btn.dataset.wishlistHandle, saved } }));
});

new MutationObserver((mutations) => {
  for (const m of mutations) {
    for (const node of m.addedNodes) {
      if (node.nodeType === 1 && (node.matches?.('[data-wishlist-handle]') || node.querySelector?.('[data-wishlist-handle]'))) {
        sync(node.parentElement ?? document);
        return;
      }
    }
  }
}).observe(document.body, { childList: true, subtree: true });

sync();
